import { Box, useTheme } from "@mui/material";
import { PieChart } from "@mui/x-charts";
import { memo } from "react";
import { IDashboardPieChartProps } from "./models";
import { DashboardNoData } from "../DashboardNoData/DashboardNoData";
import { useDashboard } from "../../../../../store/contexts/DashBoardContext";

export const DashboardPieChart = memo(({ data }: IDashboardPieChartProps) => {
  const theme = useTheme();

  const { height, width } = useDashboard();

  if (data.length === 0 || data.every((item) => item.value === 0)) {
    return <DashboardNoData />;
  }

  return (
    <Box
      sx={(t) => ({
        mt: 1,
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: `1px solid ${t.palette.divider}`,
        borderRadius: 2,
        backgroundColor: t.palette.background.default,
        minHeight: 250,
      })}
    >
      <PieChart
        colors={[theme.palette.primary.main, "#ff9500"]}
        series={[
          {
            data,
            arcLabel: (item) => `${item.value}%`,
            arcLabelMinAngle: 35,
            valueFormatter: (item) => `${item.value}%`,
            innerRadius: ((height ?? 0) * 0.2) / 4,
            outerRadius:
              (height ?? 0) < 300 ? (height ?? 0) * 0.3 : (height ?? 0) * 0.2,
            paddingAngle: 3,
            cornerRadius: 5,
            highlightScope: { faded: "global", highlighted: "item" },
            faded: {
              innerRadius: 30,
              additionalRadius: -30,
            },
          },
        ]}
        slotProps={{
          pieArc:
            width && width < 300 && height && height < 200
              ? { transform: "translate(40, -40)" }
              : width && width < 700
              ? {
                  transform: "translate(40, -5)",
                }
              : undefined,
          legend:
            width && width < 700
              ? {
                  position: { horizontal: "middle", vertical: "bottom" },
                  direction: "row",
                }
              : undefined,
        }}
        sx={(t) => ({
          "& .MuiPieArcLabel-root": {
            fill: "#fff",
            display:
              height && height < 200 && width && width < 700
                ? "none"
                : undefined,
          },
          "& .MuiChartsLegend-root": {
            textTransform: "capitalize",
            marginTop: width && width < 700 ? t.spacing(2) : 0,
            display: width && width < 700 ? "flex" : undefined,
            justifyContent: width && width < 700 ? "center" : undefined,
          },
          "& .MuiChartsLegend-mark": {
            rx: "50%",
          },
        })}
        width={width ? width * 0.4 : 600}
        height={
          height
            ? height < 300
              ? height
              : height < 500 && width && width < 700
              ? height * 0.7
              : height * 0.5
            : 300
        }
      />
    </Box>
  );
});
